<template>
  <section>
    <div class="page_content no_pg how_it_works">
      <div class="how_step step1">
        <div class="row">
          <div class="col-12 text-center">
            <h1>Bij ons is iedereen een winnaar!</h1>
          </div>
        </div>

        <div class="container">
          <div class="step_1_inside">

            <div class="step_1_img">
              <img src="static/img/millen_images/how_it_works_1.png" class="how_frame_desk_img">
            </div>
            <div class="step_text w-100">
              <h3 class="title blue">
                Stap 1: opwaarderen of koop een bundel via iDEAL
              </h3>
              <p class="mt-3">
                Elke keer dat je voor meer dan €10 opwaardeert of via iDEAL een bundel koopt vanaf €7,50, sms’en we je binnen een half uur je unieke speelcode voor Prepaid Surprise. En hoe hoger je aankoopbedrag, hoe groter de kans dat je wint.
              </p>
              <p class="mt-3">

              </p>
              <ul class="mt-3">
                <li>Als je je tegoed opwaardeert met een bedrag tussen €10 en €15, mag je één keer aan het rad draaien en staat er één hoofdprijs op het rad.
                </li>
                <li>Waardeer je je tegoed op met een bedrag tussen €15 en €20, dan mag je één keer aan het rad draaien en staan er twee hoofdprijzen op het rad.
                </li>
                <li>Bij een opwaardering van meer dan €20 of koop je via iDEAL de volgende <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundels</a>: Combi L, Combi XL, Combi XXL of Combi Unlimited, dan mag je twee keer aan het rad draaien en staan er drie hoofdprijzen op het rad.
                </li>
                <li>Koop je via iDEAL een bundel van minimaal €7,50 en niet meer dan €20 dan kun je één keer aan het rad draaien en staat er één hoofdprijs op het rad.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="how_step step2">
        <div class="container">
          <div class="step_2_inside">
            <div class="step_text w-100">
              <h3 class="title green">
                Stap 2: Speel het spel
              </h3>
              <p class="mt-3">
                Speel zoals jij het wil: klik op de link in de sms die je krijgt na het opwaarderen,
                of na het kopen van een bundel of wellicht een gratis speelcode die je hebt gekregen
                van Odido of klik hieronder op "Speel nu mee" en vul je telefoonnummer + speelcode in.
              </p>
              <p class="mt-3">
                <b>Zo speel je:</b><br>
                Draai aan het rad en zie meteen welke prijs je gewonnen hebt.<br>
              </p>
            </div>
            <div class="step_2_img">
              <img src="static/img/millen_images/how_it_works_2.png" class="how_frame_desk_img">
            </div>
          </div>
        </div>
      </div>

      <div class="how_step step3">
        <div class="container">
          <div class="step_3_inside">
            <div class="step_3_img">
              <img src="static/img/millen_images/how_it_works_3.png" class="how_frame_desk_img">
            </div>
            <div class="step_text w-100">
              <h3 class="title purple">
                Stap 3: Win
              </h3>
              <p class="mt-3">
                Ben jij de gelukkige winnaar? Check of je wat gewonnen hebt! Na jouw draai aan het rad zie je meteen of je een hoofdprijs gewonnen hebt en bij een opwaardering van meer dan €20 of koop je via iDEAL een <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundel</a> van €20 of meer, mag je zelfs twee keer aan het rad draaien.
              </p>
              <p class="mt-3">
                Geen hoofdprijs gewonnen? Geen zorgen, je mag namelijk altijd een Odido Surprise prijs uitkiezen, zoals: gratis belminuten of sms’jes of MB’s. Bij een opwaardering van meer dan €20 of koop je via iDEAL een <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundel</a> van €20 of meer, dan kun je ook de Odido Surprise, gratis 5 euro promo-tegoed kiezen. Met dit tegoed kun je bellen in Nederland (servicenummers zijn uitgesloten) en ook kun je van dit tegoed bundels kopen.
              </p>
              <p class="mt-3">
                Je kunt zo vaak meespelen met PrePaid Surprise als je wilt: iedere opwaardering én elke keer als je een bundel koopt vanaf €7,50, krijg je een speelcode en win je altijd. Gegarandeerd. Let op: je speelcode is 14 dagen geldig, dus wacht niet te lang!
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 justify-content-center how_btns">
            <button type="button" class="blue_btn" @click="playCode">Speel nu mee</button>
            <button type="button" class="black_secondary_btn" @click="topUpNow">Nu opwaarderen</button>
              <div class="actlink"> <a href="https://www.odido.nl/mobiel/prepaid/bundels" target="blank">    <button type="button" class="black_secondary_btn">Koop een bundel</button></a></div>
            <button type="button" class="black_secondary_btn" @click="goToPhysicalPrizes">Check de prijzen</button>
          </div>
        </div>
      </div>

    </div>
    <play-and-win v-if="playGameModal"></play-and-win>
    <accept-terms v-if="acceptTermsModal"></accept-terms>
    <lost-code v-if="lostCodeModal"></lost-code>
  </section>
</template>

<script>
  import PlayAndWin from './modals/PlayAndWin'
  import AcceptTermsPopUp from './modals/AcceptTermsPopUp'
  import LostCode from './modals/LostCode'
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import gameFlow from '../common/mixin/gameFlow'
  import router from '../router'

  export default {
    name: 'HowItWorks',
    components: {
      'play-and-win': PlayAndWin,
      'accept-terms': AcceptTermsPopUp,
      'lost-code': LostCode
    },
    mixins: [
      gameFlow
    ],
    computed: {
      ...mapGetters([
        'isPlayGameModalOpen',
        'isAcceptTermsModalOpen',
        'isLostCodeModalOpen',
        'isLostCodeModalOpen',
        'getAccessToken',
        'getMsisdn',
        'getInGameFlow'
      ]),
      playGameModal() {
        return this.isPlayGameModalOpen
      },
      acceptTermsModal() {
        return this.isAcceptTermsModalOpen
      },
      lostCodeModal() {
        return this.isLostCodeModalOpen
      }
    },
    mounted() {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      if (!this.getInGameFlow) {
        this.updateInGameFlow(false)
      }
    },
    methods: {
      ...mapMutations([
        'updatePlayGameModal',
        'updateAcceptTermsModal',
        'updateLostCodeModal',
        'updateMsisdn',
        'updateSelectedCodeForRedemption',
        'updateInGameFlow',
        'updateRedemptionMsisdn',
      ]),
      msisdnValidation() {
        return (/^(06[0-9]{8}|097[0-9]{9})$/.test(this.msisdn))
      },
      playCode() {
        if (this.getAccessToken) {
          this.updateRedemptionMsisdn(this.getMsisdn)
          this.retrieveCodeForLoggedInCustomer()
        } else {
          this.updatePlayGameModal(true)
        }
      },
      topUpNow() {
        window.open('https://opwaarderen.odido.nl', '_blank')
      },
      goToPhysicalPrizes() {
        router.push({name: 'Home', hash: '#physicalPrizeCarousel'})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HowItWorks.vue